/** @jsxImportSource @emotion/react */

import React from 'react';

import { IBlockBaseItem } from '../blockItem';

export interface IBlockShapeItem extends IBlockBaseItem {
  type: 'shape';
}

interface IBlockShapeItemProps {
  data: IBlockShapeItem;
}

const BlockShapeItem = ({ data, ...props }: IBlockShapeItemProps) => {
  return <div {...props} />;
};

export default BlockShapeItem;
